export default __webpack_public_path__ + "static/media/token_left_mobile.1c5e6376.png";